import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLanguageGetAll } from '../../redux/slices/languageGetAllSlice'
import CrudFormGroup from './CrudFormGroup'
import CMSTable from '../../components/general/CMSTable'
import { columns } from '../../utilities/columns/formGroupColumns'
import { useNavigate } from 'react-router-dom'
import { fetchFormGroupDelete } from '../../redux/slices/formGroupDeleteSlice'
import { fetchFormGroupGetAll } from '../../redux/slices/formGroupGetAllSlice'
import { fetchPageGetAll } from '../../redux/slices/pageGetAllSlice'

const FormPage = () => {
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [data, setData] = useState([])
    const [changed, setChanged] = useState(false)
    const lang = useSelector(state => state.lang.lang)
    const languages = useSelector(state => state.languageGetAll.data)
    const navigation = useNavigate()
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchLanguageGetAll())
        await dispatch(fetchPageGetAll())
        var data = await dispatch(fetchFormGroupGetAll())
        if (data.payload) {
            setData(data.payload)
        }
        setChanged(false)
    }

    const deleteData = async (id) => {
        await dispatch(fetchFormGroupDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                title={t("form_management")}
                description={t("form_management_description")}
                modal={modal}
                setModal={setModal}
                buttonText={t("form_group_add")}
            />

            <CMSTable
                columns={columns({
                    t: t,
                    modal: modal,
                    setModal: setModal,
                    lang: lang,
                    deleteData: deleteData,
                    navigation: navigation,
                    setSelectedItem: setSelectedItem
                })}
                data={data}
            />

            <CrudFormGroup
                languages={languages}
                setChanged={setChanged}
                showMenu={modal}
                setShowMenu={setModal}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default FormPage
